/**
 * A count for display, written the same on the server and in every browser:
 * Latin digits, comma grouping ("1,234").
 *
 * WHY NOT toLocaleString(). With no locale it formats in the runtime's own:
 * Node's on the server, the browser's in the browser. A count the server
 * renders and the browser then hydrates must print identical characters, and
 * a browser set to Arabic writes 4 as "٤", Persian as "۴", German groups
 * thousands with a full stop. React then throws a hydration error (#418) and,
 * with nothing wrapping the app in a Suspense boundary, redraws the whole page.
 * Measured on /marketplace on 2026-10-07 for ar-EG and fa-IR browsers.
 *
 * en-AU is the site's own locale; its integer formatting is the same in every
 * engine.
 */
export function formatCount(n: number): string {
  return n.toLocaleString('en-AU');
}
